/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DdexCopyright
 */
export interface DdexCopyright {
    /**
     * Copyright year (4 characters)
     * @type {string}
     * @memberof DdexCopyright
     */
    year: string;
    /**
     * Copyright text
     * @type {string}
     * @memberof DdexCopyright
     */
    text: string;
}

/**
 * Check if a given object implements the DdexCopyright interface.
 */
export function instanceOfDdexCopyright(value: object): value is DdexCopyright {
    let isInstance = true;
    isInstance = isInstance && "year" in value && value["year"] !== undefined;
    isInstance = isInstance && "text" in value && value["text"] !== undefined;

    return isInstance;
}

export function DdexCopyrightFromJSON(json: any): DdexCopyright {
    return DdexCopyrightFromJSONTyped(json, false);
}

export function DdexCopyrightFromJSONTyped(json: any, ignoreDiscriminator: boolean): DdexCopyright {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': json['year'],
        'text': json['text'],
    };
}

export function DdexCopyrightToJSON(value?: DdexCopyright | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': value.year,
        'text': value.text,
    };
}

